import { useIntl } from 'react-intl'
import { FilterSelect } from '@/components/ui-shared/Tables/FilterSelect/FilterSelect'

type StatusFilterProps = {
  value: string | null
  onChange: (value: string | null) => void
}

export const StatusFilter = ({ value, onChange }: StatusFilterProps) => {
  const intl = useIntl()

  return (
    <FilterSelect
      w={220}
      value={value}
      data={[
        {
          value: 'online',
          label: intl.formatMessage({ id: 'devices.status.online' })
        },
        {
          value: 'offline',
          label: intl.formatMessage({ id: 'devices.status.offline' })
        }
      ]}
      placeholder={intl.formatMessage({
        id: 'cameras.list.filter.status.placeholder'
      })}
      onChange={onChange}
    />
  )
}
